// extracted by mini-css-extract-plugin
export default {"tierBadge":"TierBadge_tierBadge__2slNL","tier_1":"TierBadge_tier_1__GBXbp","tier_2":"TierBadge_tier_2__V5-6P","tier_3":"TierBadge_tier_3__jjsrZ","tier_4":"TierBadge_tier_4__t3R9B"};